var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('SvgImage',{ref:"icon",staticClass:"block",attrs:{"animate":_vm.animateProp,"animation":"animate-draw-flowers-alternate","offset":"1000","icon":_vm.icon,"width":_vm.width,"height":_vm.height}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }